export enum PlantValidationActions {
  FETCH_PLANT_VALIDATIONS_LOADING = "FETCH_PLANT_VALIDATIONS_LOADING",
  FETCH_PLANT_VALIDATIONS_SUCCEEDED = "FETCH_PLANT_VALIDATIONS_SUCCEEDED",
  FETCH_PLANT_VALIDATIONS_FAILED = "FETCH_PLANT_VALIDATIONS_FAILED",
}